import React, { Suspense } from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { sidebarOpened, useStore } from "../../helpers";
import { Spinner } from "../../Spinner";
import sxStyles from "./Main.style";
const Main = ({ children, className, topElement, sx, hasSidebar = true }) => {
    const { breakpoints } = useTheme();
    const isLargeScreen = useMediaQuery(breakpoints.up("xl"));
    const isSidebarOpened = useStore(sidebarOpened);
    return (React.createElement(Box, { sx: (theme) => ({
            ...sxStyles(theme).root,
            paddingLeft: hasSidebar && isLargeScreen && isSidebarOpened ? 27 : 6,
        }) },
        topElement,
        React.createElement(Box, { component: "main", className: className, sx: [{ padding: (theme) => theme.spacing(3, 3, 3, 3) }, ...(Array.isArray(sx) ? sx : [sx])] },
            React.createElement(Suspense, { fallback: React.createElement(Spinner, { isFixed: true }) }, children))));
};
export default Main;
//# sourceMappingURL=Main.js.map